// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2M1Oheb"};